export default {
  Title: 'New caregiver',
  CaregiverName: 'Caregiver Name',
  CaregiverDescription: 'Caregiver Description',
  CreateNewCaregiver: 'Create new caregiver',
};
